import React from "react";
import LoadingBar from "Shared/LoadingBar";

const Loading = () => {
    return (
        <div className={`accessories_loading`}>
            <div>
                <LoadingBar />
            </div>
        </div>
    );
};

export default Loading;
